import classNames from 'classnames'
import React from 'react'
import {
  isNullOrWhiteSpace,
  sanitizeHtmlAndReplaceNewlines,
} from '../../utilities/string'
import { Grid } from '../Grid'

export interface HeadingProps {
  heading?: string
  preamble?: string
  subheading?: string
}

export const PageHeader = ({ heading, preamble, subheading }: HeadingProps) => {
  if (!heading && !preamble && !subheading) {
    return null
  }

  return (
    <Grid>
      <div
        className={classNames(
          'col-span-full',
          'tb:col-start-2 tb:col-span-2',
          'sm:col-start-2 sm:col-span-4 sm:px-90',
          'md:px-0',
          'lg:col-start-3 lg:col-span-4',
          'xl:col-start-3 xl:col-span-6',
          'xxl:col-start-5 xxl:col-span-6'
        )}
      >
        <header className="text-center">
          {!isNullOrWhiteSpace(heading) && (
            <h1 className="font-h1 text-h1 text-primary">{heading}</h1>
          )}

          {!isNullOrWhiteSpace(subheading) && (
            <h2
              className={classNames(
                'mt-15 font-h2 text-h2 text-secondary-darker',
                'tb:mt-30'
              )}
            >
              {subheading}
            </h2>
          )}

          {!isNullOrWhiteSpace(preamble) && (
            <p
              className={classNames(
                'mt-15 font-t text-t-500 text-secondary-darker',
                'sm:px-30',
                'md:px-0 md:text-t-600',
                'xl:px-60 xl:text-t-700',
                'xxl:px-0 xxl:mt-30 xxl:text-t-800'
              )}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtmlAndReplaceNewlines(preamble),
              }}
            />
          )}
        </header>
      </div>
    </Grid>
  )
}
